import {makeStyles} from "@material-ui/core/styles";

export const useBoxWithImageStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        minHeight: '125px',
        display: 'flex',
        alignItems: 'center'
    },
    title: {
        color: '#757575 !important',
        wordBreak: props => props.isWordBreak ? "break-all" : "keep-all"
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        marginTop: '5px',
        display: 'block',
        width: "60px",
        height: "60px"
    },
    breakWord: {
        wordBreak: "break-all"
    }
}));
